import { useEffect, useState } from 'react';
import { Checkbox } from '../widgets/checkbox/checkbox';
import { Pane } from './pane';
import * as cn from 'classnames';
import { CollapsableContainer, CollapsableContainerHeader } from '../widgets/collapsable-container-header/collapsable-container-header';
import { useFilter, useFilterDispatch } from '../../contexts/filter-context';
import Collapsible from 'react-collapsible';
import { RatingSelect } from '../widgets/rating-select/rating-select';
import { Search } from '../widgets/search/search';
import { Button } from '../widgets/button/button';
import { ReactComponent as RecommendIcon } from '../../assets/recommendation.svg';

export const OrganizationSearchPane = ({ ecosystemPhases, activities, causes, onEcosystemPhaseFiltersChange, onCauseFiltersChange, visible }) => {
  const state = useFilter();
  const dispatch = useFilterDispatch();

  const handlePhaseClicked = (phaseItem) => {
    // onEcosystemPhaseFiltersChange?.({ ...phaseItem, checked: !phaseItem.checked });
    dispatch({ type: 'phase-toggled', phaseId: phaseItem.ID });
  };

  const handleActivityClicked = (activityItem) => {
    // onCauseFiltersChange?.({ ...activityItem, checked: !activityItem.checked });
    dispatch({ type: 'activity-toggled', activityId: activityItem.ID });
  };

  const handleStarsSelect = (starNum) => {
    dispatch({ type: 'charity-navigator-rating-set', stars: starNum });
  };

  const onClearPhases = () => {
    dispatch({ type: 'phase-cleared' });
  };
  const onClearActivities = () => {
    dispatch({ type: 'activity-cleared' });
  };
  const onClearStarRating = () => {
    dispatch({ type: 'charity-navigator-rating-set', stars: '' });
  };

  const handleShareOrgClicked = () => {
    window.open('https://docs.google.com/forms/d/e/1FAIpQLSdefz37dZGpRcNm2VTGTOy1y9JhyiGR-xoq6JzfXZk9kAWZ-Q/viewform?usp=dialog', '_blank', 'noopener');
  };

  return (
    <Pane visible={visible}>
      <div className="paneSection" style={{ marginTop: 8 }}>
        <Collapsible trigger={<CollapsableContainerHeader label="Search" />} easing="ease" open={true}>
          <Search />
        </Collapsible>
      </div>
      <div className="paneSection" style={{ marginTop: 8 }}>
        <Collapsible trigger={<CollapsableContainerHeader label="Phases" count={state.phaseIds.length} onClear={onClearPhases} />} easing="ease" open={true}>
          {ecosystemPhases.map((ep, index) => (
            <Checkbox key={index} checked={state.phaseIds.includes(ep.ID)} onClick={() => handlePhaseClicked(ep)}>
              {ep.NAME}
            </Checkbox>
          ))}
        </Collapsible>
      </div>
      <div className="paneSection" style={{ marginTop: 8 }}>
        <Collapsible trigger={<CollapsableContainerHeader label="Activities" count={state.activityIds.length} onClear={onClearActivities} />} easing="ease">
          {activities.map((a, index) => (
            <Checkbox key={index} checked={state.activityIds.includes(a.ID)} onClick={() => handleActivityClicked(a)}>
              {a.NAME}
            </Checkbox>
          ))}
        </Collapsible>
      </div>
      <div className="paneSection" style={{ marginTop: 8 }}>
        <Collapsible
          trigger={<CollapsableContainerHeader label="Minimum star rating" count={state.stars} onClear={onClearStarRating} hideCount={true} />}
          easing="ease"
          open={true}
        >
          <RatingSelect onStarsSelect={handleStarsSelect} minStars={3} />
        </Collapsible>
      </div>
      <div className="paneSection" style={{ marginTop: 8 }}>
        <Button icon={<RecommendIcon style={{ width: '10%', height: 'auto', marginLeft: '-43' }} />} onClick={handleShareOrgClicked}>
          Share an Organization
        </Button>
      </div>
    </Pane>
  );
};
